/**
 * Returns true when the host page URL has `?debug=true`.
 * Used to enable iframe-resizer verbose logging.
 */
export const isDebugMode = (): boolean => {
  if (typeof window === 'undefined') return false
  return new URLSearchParams(window.location.search).get('debug') === 'true'
}
